/**
 * SectionHeader 컴포넌트
 * @description 섹션 한 줄의 머리 — 제목과, 있으면 "See all". 시안 `3041:2420`.
 *   제목 옆에 무엇이 붙을지는 화면이 정한다(`trailing`). 앱 `Section/SectionHeader` 의 웹 포팅.
 * @example
 * <SectionHeader title="You might want to connect" seeAllHref="/explore/people" />
 */
import Link from "next/link";
import { memo } from "react";

import { sectionHeaderStyles } from "./SectionHeader.styles";
import type { SectionHeaderProps } from "./Section.types";

/** 앱 `common:button.seeAll` */
const SEE_ALL_LABEL = "See All";

const SectionHeader = memo<SectionHeaderProps>(
  ({ title, trailing, seeAllHref, onSeeAll, seeAllLabel, testID }) => {
    const label = seeAllLabel ?? SEE_ALL_LABEL;
    const ariaLabel = `${title} — ${label}`;

    return (
      <div className={sectionHeaderStyles.root} data-testid={testID}>
        <div className={sectionHeaderStyles.lead}>
          <h2 className={sectionHeaderStyles.title}>{title}</h2>
          {trailing}
        </div>
        {seeAllHref ? (
          <Link
            href={seeAllHref}
            className={sectionHeaderStyles.seeAll}
            aria-label={ariaLabel}
          >
            {label}
          </Link>
        ) : onSeeAll ? (
          <button
            type="button"
            className={sectionHeaderStyles.seeAll}
            onClick={onSeeAll}
            aria-label={ariaLabel}
          >
            {label}
          </button>
        ) : null}
      </div>
    );
  },
);

SectionHeader.displayName = "SectionHeader";

export default SectionHeader;
